module.exports = __webpack_public_path__ + "src/assets/img/industry1.66678c4b.png";